var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.sortedEntries.length)?_c('apexchart',{attrs:{"type":"bar","height":Math.max(300, _vm.sortedEntries.length * 44 + 80),"options":_vm.opts,"series":_vm.series}}):_c('empty-state',{attrs:{"icon":"mdi-account-check-outline","title":_vm.$t('no_data')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }